import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import { SubPageLayout } from '../sub-page-layout';
import { useNavigate } from 'react-router-dom';
import { RoleCreateContainer } from '../components/role-create.container';
import { Helmet } from 'react-helmet';

export const RolesCreate: React.FC<any> = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Role - Create</title>
      </Helmet>
      <SubPageLayout
        header={
          <PageHeader
            title={<Typography.Title style={{ paddingBottom: '0px', fontSize: '30px', marginTop: '12px' }}>Create Role</Typography.Title>}
            onBack={() => navigate(-1)}
          ></PageHeader>
        }
      >
        <RoleCreateContainer />
      </SubPageLayout>
    </>
  );
};
